// src/style-comps/AdminListing.styles.js
import styled from "styled-components";

// Container 改成 flex column 且不再自己捲動；真正捲動移到 TableWrapper（見下方），
// 這樣 Search/Filter 跟 Pagination 永遠固定在畫面上，只有表格內容上下滑動，
// Table Header 也才能正確 sticky（TableWrapper 原本的 overflow-x:auto 會變成離
// TableHead 最近的捲動容器，若它自己沒有實際捲動，sticky 會完全失效）。
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 28px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
  color: #333;
`;

export const ControlBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-shrink: 0;
`;

export const SearchInput = styled.input`
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #ccc;
  width: 260px;
  font-size: 14px;
  transition: all 0.2s ease-in-out;
  &:focus {
    border-color: #61cbc9;
    outline: none;
    box-shadow: 0 0 4px rgba(97, 203, 201, 0.4);
  }
`;

// 真正負責上下/左右捲動的容器：flex:1 + min-height:0 讓它吃滿 Container 剩下的
// 高度並在內部自己捲動，TableHead 的 position:sticky 就是相對「這一層」在固定。
export const TableWrapper = styled.div`
  width: 100%;
  min-height: 0;
  flex: 1;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
`;

export const TableHead = styled.thead`
  position: sticky;
  top: 0;
  background-color: #f9fafb;
  border-bottom: 2px solid #eaeaea;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
`;

// $rowState: 'off-listed'（PMS Off 但仍 Listed，需要注意）/ 'off-unlisted'（PMS Off 且 Unlisted，正常關閉）
export const TableRow = styled.tr`
  font-size: 14px;
  transition: background 0.2s, box-shadow 0.2s;
  background-color: ${({ $rowState }) =>
    $rowState === "off-listed" ? "#fdefab" : $rowState === "off-unlisted" ? "#f5f5f5" : "transparent"};
  color: ${({ $rowState }) => ($rowState === "off-unlisted" ? "#999" : "inherit")};
  &:hover {
    background-color: ${({ $rowState }) =>
      $rowState === "off-listed" ? "#fbe58a" : $rowState === "off-unlisted" ? "#eeeeee" : "#f7fdfc"};
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05);
  }
`;

export const TableHeader = styled.th`
  padding: 14px 16px;
  text-align: left;
  font-weight: 600;
  color: #444;
  white-space: nowrap;
  border-bottom: 2px solid #eaeaea;
`;

export const TableBody = styled.tbody``;

export const TableData = styled.td`
  padding: 14px 16px;
  border-bottom: 1px solid #f1f1f1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
`;

// $variant="warning"：PMS Off 但仍 Listed 時，Listed pill 改用品牌 Secondary 橘色標示需要注意
// $muted：PMS Off 且 Unlisted 時，同一列的其他 pill（Parent/Child）一起淡化，跟反灰的列背景一致
export const StatusPill = styled.span`
  display: inline-block;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ active, $variant, $muted }) =>
    $variant === "warning" ? "#fff" : $muted ? "#999" : active ? "#fff" : "#555"};
  background-color: ${({ active, $variant, $muted }) =>
    $variant === "warning" ? "#f98c28" : $muted ? "#dcdcdc" : active ? "#61cbc9" : "#e0e0e0"};
`;

export const StatementPill = styled.span`
  display: inline-block;
  padding: 5px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: ${({ stage }) =>
    stage === "Statement Sent"
      ? "#fff"
      : stage === "Draft"
        ? "#333"
        : "#fff"};
  background-color: ${({ stage }) =>
    stage === "Draft"
      ? "#FFD966"
      : stage === "Statement Sent"
        ? "#FF6B4A"
        : "#7AD17D"};
`;

export const ActionCell = styled.td`
  display: flex;
  align-items: center;
  gap: 14px;
  justify-content: flex-start;
  padding: 12px 16px;

  svg {
    cursor: pointer;
    color: #777;
    transition: all 0.2s ease;
  }
  svg:hover {
    color: #333;
    transform: scale(1.1);
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 6px;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 10px;
  flex-shrink: 0;
`;

export const PageButton = styled.button`
  padding: 6px 12px;
  border-radius: 6px;
  background: ${({ active }) => (active ? "#61cbc9" : "transparent")};
  border: 1px solid ${({ active }) => (active ? "#61cbc9" : "#ccc")};
  color: ${({ active }) => (active ? "#fff" : "#333")};
  cursor: pointer;
  min-width: 36px;
  font-size: 14px;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(97, 203, 201, 0.15);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const RowsSelect = styled.select`
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 14px;
  background-color: white;
  color: #333;
  transition: all 0.2s;
  &:hover {
    border-color: #61cbc9;
  }
`;

export const PageSelect = styled.select`
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 14px;
  background-color: white;
  color: #333;
  transition: all 0.2s;
  &:hover {
    border-color: #61cbc9;
  }
`;

export const SyncWrap = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  display: flex;
  gap: 12px;
  z-index: 10;
`;

export const SyncButton = styled.button`
  padding: 12px 20px;
  border-radius: 30px;
  background-color: #ff6600;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background-color: rgba(255, 102, 0, 0.8);
  }
  img {
    width: 16px;
    height: 16px;
    transition: transform 0.2s ease;
  }
  &:hover img {
    transform: rotate(-20deg);
  }
`;

export const ErrorPopup = styled.div`
  position: fixed;
  top: 70px;
  right: -600px;
  transform: translateY(0%);
  background-color: rgba(97, 203, 201, 0.4);
  color: #333;
  padding: 12px 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: right 0.5s ease-in-out;
  ${({ show }) => show && `right: 10px;`}
`;

export const CloseButton = styled.button`
  background-color: transparent;
  color: #333;
  border: none;
  font-size: 24px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  font-weight: bold;
  &:hover {
    color: #61cbc9;
  }
`;

// ---- 篩選 Checkbox 區 ----
export const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
`;

export const FilterLabel = styled.label`
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  user-select: none;
  cursor: pointer;
  color: #333;
  font-weight: 500;
  letter-spacing: 0.3px;

  input[type="checkbox"] {
    appearance: none;             /*  自訂 checkbox */
    width: 16px;
    height: 16px;
    border: 2px solid #61cbc9;    /*  外框顏色 */
    border-radius: 4px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  input[type="checkbox"]:checked {
    background-color: #61cbc9;    /
    border-color: #61cbc9;
  }

  input[type="checkbox"]:checked::after {
    content: "✓";                 /*  自訂打勾符號 */
    position: absolute;
    top: -2px;
    left: 2px;
    font-size: 14px;
    color: white;                 /*  勾選顏色 */
  }

`;




